import React from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'
import Multimaxi from './pages/Multimaxi'
import MultimaxiSplit from './pages/MultimaxiSplit'
import Home from './components/Home'
import { reload } from './helpers/helpers'
import ErrorBoundary from './components/ErrorBoundary'
import { reactPlugin } from './irtis-3/utils/application-insights.utils'
import { withAITracking } from '@microsoft/applicationinsights-react-js'
import Irtis3Page from './irtis-3/Irtis3Page'

import '@delijn/fonts'

const reloadPageTime = 3600 * 2 * 1000 // 2 hours

function App() {
  React.useEffect(() => {
    setTimeout(reload, reloadPageTime)
  }, [])
  return (
    <Routes>
      <Route path="/realtime/home" element={<Home />} />
      <Route
        path="/realtime/:haltenummers/:aantal"
        element={
          <ErrorBoundary>
            <Multimaxi />
          </ErrorBoundary>
        }
      />
      <Route
        path="/realtime/multimaxi/:haltenummers/:aantal"
        element={
          <ErrorBoundary>
            <Multimaxi />
          </ErrorBoundary>
        }
      />
      <Route
        path="/realtime/multimaxi-split/:haltenummers"
        element={
          <ErrorBoundary>
            <MultimaxiSplit />
          </ErrorBoundary>
        }
      />
      <Route
        path="/realtime/irtis/:haltenummers/:aantal"
        element={
          <ErrorBoundary>
            <Irtis3Page />
          </ErrorBoundary>
        }
      />

      <Route path="*" element={<Navigate to="/realtime/home" replace />} />
    </Routes>
  )
}

export default withAITracking(reactPlugin, App, 'App', 'h-full')
